import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { PlatformFilterState } from './platformfilter.state';
import { getters } from './platformfilter.getters';
import { mutations } from './platformfilter.mutations';
import { actions } from './platformfilter.actions';

VueXHelper.setStoreModule(Module.PLATFORMFILTER, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new PlatformFilterState(),
  getters,
  mutations,
  actions,
};
